import React, { useState } from "react";
import { Input } from "antd";

const { TextArea: AntdTextArea } = Input;

const TextArea = ({
	defaultValue,
	dispatch,
	name,
	questionId,
	isNew,
	rows,
	dataType,
	row,
	...otherProps
}) => {
	const [state, setState] = useState(defaultValue);
	const [isTouched, setIsTouched] = useState(false);

	const [answerAdded, answerEdited] = dispatch;
	const handleDispatch = () => {
		if (isTouched) {
			let data = {
				questionId: questionId,
				id: name,
				value: state,
				row: row,
				dataType: dataType,
			};
			if (!isNew) answerEdited(data);
			else answerAdded(data);
			setIsTouched(false);
		}
	};
	const handleKeyDown = (e) => {
		if (e.which !== 9) setIsTouched(true); //not dirty on tab
	};
	return (
		<AntdTextArea
			autoSize={{ minRows: rows }}
			onBlur={handleDispatch}
			onKeyDown={handleKeyDown}
			onChange={(e) => setState(e.target.value)}
			name={name}
			defaultValue={!isTouched ? defaultValue : state}
			value={state}
			{...otherProps}
		/>
	);
};

export default TextArea;
